const sharedStatusFields = [
  'share_status',
  'shared_template_id',
  'shared_version',
  'shared_verification_status',
];

export const applySharedTemplateStatuses = (templates, updates) => {
  if (!Array.isArray(templates) || !Array.isArray(updates) || updates.length === 0) {
    return templates;
  }

  const updatesById = new Map(
    updates
      .filter((update) => update && update.id !== undefined && update.id !== null)
      .map((update) => [String(update.id), update]),
  );

  return templates.map((template) => {
    const update = updatesById.get(String(template?.id));
    if (!update) return template;
    const status = {};
    sharedStatusFields.forEach((field) => {
      if (Object.prototype.hasOwnProperty.call(update, field)) {
        status[field] = update[field];
      }
    });
    return { ...template, ...status };
  });
};
